import { Tag, TagCloseButton, TagLeftIcon } from '@chakra-ui/react';

import type { IconType } from 'react-icons';
import type { Maybe } from '@/client/services/api/graphql/gql/graphql';

interface SegmentationTagProps {
  name: Maybe<string> | undefined;
  icon: IconType;
  renderCloseButton?: boolean;
  onRemove: () => void;
}

export default function SegmentationTag({
  name,
  icon,
  renderCloseButton = true,
  onRemove,
}: SegmentationTagProps) {
  return (
    <Tag variant="create" marginX={0}>
      <TagLeftIcon as={icon} />

      {name}

      {renderCloseButton && <TagCloseButton onClick={onRemove} />}
    </Tag>
  );
}
